'use client';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { label: 'Marketplace', href: '/global-halal-marketplace' },
  { label: 'Certification', href: '/digital-certification-registry' },
  { label: 'Investment', href: '/halal-investment-exchange' },
  { label: 'About', href: '/' },
];

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? 'rgba(8, 14, 26, 0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid var(--border)' : 'none',
      }}
    >
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 flex items-center justify-between h-16">
        <Link href="/" className="flex items-center gap-2">
          <AppLogo src="/assets/images/Halalchamp_png-1783699489068.png" size={36} />
          <span className="font-bold text-base hidden sm:block" style={{ color: 'var(--gold)' }}>
            HalalCham
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-6">
          {navLinks?.map((link) => (
            <Link
              key={`navlink-${link?.label}`}
              href={link?.href}
              className="text-sm font-medium transition-colors hover:text-emerald-bright"
              style={{ color: 'var(--secondary-foreground)' }}
            >
              {link?.label}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link href="/login-role-selection" className="btn-outline px-4 py-2 rounded-lg text-sm font-medium">
            Sign In
          </Link>
          <Link href="/main-dashboard" className="btn-primary px-4 py-2 rounded-lg text-sm font-semibold">
            Launch Dashboard
          </Link>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden p-2 rounded-lg btn-outline"
        >
          {mobileOpen ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {mobileOpen && (
        <div
          className="md:hidden border-t px-6 py-4 space-y-3"
          style={{ background: 'var(--secondary)', borderColor: 'var(--border)' }}
        >
          {navLinks?.map((link) => (
            <Link
              key={`mobile-navlink-${link?.label}`}
              href={link?.href}
              className="block text-sm font-medium py-2 transition-colors hover:text-emerald-bright"
              style={{ color: 'var(--secondary-foreground)' }}
              onClick={() => setMobileOpen(false)}
            >
              {link?.label}
            </Link>
          ))}
          <div className="flex gap-3 pt-2">
            <Link href="/login-role-selection" className="btn-outline px-4 py-2 rounded-lg text-sm font-medium flex-1 text-center">
              Sign In
            </Link>
            <Link href="/main-dashboard" className="btn-primary px-4 py-2 rounded-lg text-sm font-semibold flex-1 text-center">
              Dashboard
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}